import React, { useMemo } from "react";
import {
  HyperElements,
  HyperElementsAppearance,
  PaymentElement,
} from "@juspay-tech/react-hyper-js";
import { useSaveHyperElements } from "../hooks/useHyperPayment";
import { Theme } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { makeRootStyles } from "../../theme/styles";

import { loadHyper } from "@juspay-tech/hyper-js";

export const createHyperPromise = (key: string) => loadHyper(key);

export interface HyperSwitchProps {
  secret: string;
  backendPaymentFailureError?: string;
  paymentProcessorPubKey: string;
}

const HyperElement = () => {
  useSaveHyperElements();
  return (
    <PaymentElement id="payment-element" options={{ branding: "never" }} />
  );
};

const useStyles = makeRootStyles(
  (theme: Theme) => ({
    errorText: {
      color: theme.palette.error.main,
    },
  }),
  { name: "N0HyperSwitch" },
);

const getAppearance = (): HyperElementsAppearance => ({
  rules: {
    ".Tab": {
      display: "none",
    },
    ".Checkbox": {
      display: "none",
    },
  },
});

const HyperSwitch = ({
  secret,
  backendPaymentFailureError = "",
  paymentProcessorPubKey,
}: HyperSwitchProps) => {
  const classes = useStyles();
  const hyperPromise = useMemo(
    () => createHyperPromise(paymentProcessorPubKey),
    [paymentProcessorPubKey],
  );

  return (
    <Grid>
      <HyperElements
        hyper={hyperPromise}
        options={{
          clientSecret: secret,
          appearance: getAppearance(),
        }}>
        <HyperElement />
      </HyperElements>
      {backendPaymentFailureError && (
        <Grid xs={12} item>
          <Typography
            align="center"
            variant="body1"
            className={classes.errorText}>
            {backendPaymentFailureError}
          </Typography>
        </Grid>
      )}
    </Grid>
  );
};

export default HyperSwitch;
